import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'gtd-card',
  standalone: true,
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() theme = 'default';
  @Input() cardClass: string;
  @ContentChild('cardHeader') cardHeader?: ElementRef;
  @ContentChild('cardFooter') cardFooter?: ElementRef;
}
